import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {AuthDataService} from "../../services/auth-data.service";

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  form!: FormGroup;

  constructor(
    private router: Router,
    private authDataService: AuthDataService
  ) {
  }

  ngOnInit() {
    this.initForm()
  }

  initForm(): void {
    this.form = new FormGroup({
      emailFormControl: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  get emailFormatError() {
    return this.form.get('emailFormControl')?.hasError('email')
  }

  get emailRequiredError() {
    return this.form.get('emailFormControl')?.hasError('required')
  }

  sendForm() {
    const email = this.form.get('emailFormControl')?.value
    if (email) {
      this.authDataService.sendRequestRecoveryPassword(email).subscribe({
        next: (res) => {
          this.router.navigate(['/recovery-password/request-send'])
        }
      })
    }
  }
}
